<div [formGroup]="form"
     class="flex-col gap-16">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.NODES.ALERTTRIGGER.EVENT'|translate }} <span class="required">*</span></label>

        <mat-select formControlName="eventId"
                    class="ui-selector ui-selector-40"
                    panelClass="selector-option-full-width list-item-48-height"
                    [multiple]="false"
                    [placeholder]="!selectEventsSig()?.length ? ('FLOW_CHART.LOADING_EVENTS'|translate) : ('FLOW_CHART.NODES.ALERTTRIGGER.PLACEHOLDERS.SELECT'|translate)"
                    (openedChange)="onPanelOpen($event, searchInput)">

            <div class="search-wrapper">
                <input #searchInput
                       class="ui-input w-100"
                       [formControl]="searchQuery"
                       [placeholder]="'COMMON.SEARCH'|translate"
                       (click)="$event.stopPropagation()"
                       (keydown)="$event.stopPropagation()" />

                @if(searchQuery.value) {
                <span class="input-icon-end ui-icon-close ui-mat-icon-16"
                      [matTooltip]="'COMMON.CLEAR' | translate"
                      (click)="clear()">
                </span>
                }
            </div>

            @for(item of selectEventsSig(); track item) {
            <div class="p-r">
                <mat-option [value]="item[valueProperty]"
                            [class.hide]="!(filteredItemsSig()?.has(item[valueProperty]))"
                            style="height: 64px;">
                    <div class="flex-row start-center gap-16">
                        <event-camera-snapshot [formValue]="item.selectedFlow?.formValue"></event-camera-snapshot>
                        {{ getValue(item, searchProperty) }}
                    </div>
                </mat-option>
            </div>
            }
        </mat-select>
    </div>

</div>